import { get, post, put, remove } from "../../utils/httpClient";

const stageService = () => {
  const prefixApi = "duedates/stages";

  const getStages = async (boardId) => {
    return await get(`/${prefixApi}/board`, { boardId: boardId });
  };

  const createStage = async (json) => {
    return await post(`/${prefixApi}`, json);
  };

  const updateStage = async (json) => {
    return await put(`/${prefixApi}`, json);
  };

  const updateStageOrder = async (json) => {
    return await put(`/${prefixApi}/order`, json);
  };

  const deleteStage = async (id) => {
    return await remove(`/${prefixApi}/${id}`);
  };

  return {
    getStages,
    createStage,
    updateStage,
    updateStageOrder,
    deleteStage,
  };
};

export default stageService;
